module.exports = __webpack_public_path__ + "static/media/cy-lab-debate.e94ca3e9.png";